/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.BusinessTypes {
    angular.module("meevo.plugins.businessTypes", []);
}